export enum Severity {
  Information = 'info',
  Warning = 'warning',
  Error = 'error',
  Critical = 'critical',
  Debug = 'debug',
}
